import { useLocation } from '@remix-run/react';

import { QUERY_PARAM_REGEX, UUID_REGEX } from 'shared/helpers/constants';

/**
 * Converts url params to metrics-readable object
 * {abc: "foo", def: "[asf]", xyz: "5"}
 *
 * @param search - url search params
 */
export const searchParamsToObject = (search: string) =>
  Object.fromEntries(new URLSearchParams(search));

/**
 * Converts metrics-readable object to url params
 *
 * @returns url search params
 */
export const usePath = (): string => {
  const { pathname } = useLocation();
  return normalizePathname(pathname);
};

const OFFER_ID_REGEX = /\/buy\/offer\/([a-fA-F0-9-]+)/g;

/**
 * Converts pathnames into a simplified format for metrics
 *
 * i.e. /dashboard/sell8f89f45b-fbfb-529c-964f-2d2c1392af36/schedule?query=param&another=param becomes `sell/schedule`
 */
export const normalizePathname = (pathname: string): string => {
  let path = pathname;

  // Buyer offer Ids do not follow the same structure. We need to normalize them first
  if (pathname.match(OFFER_ID_REGEX)) {
    path = pathname.replace(OFFER_ID_REGEX, '/buy/offer');
  }

  return (
    path
      // Strip all UUIDs
      .replaceAll(UUID_REGEX, '')
      // Strip all query params
      .replace(QUERY_PARAM_REGEX, '')
      .replace('dashboard/', '')
      .replace('monitor/', '')
      .replace('customer/', '')
      // Trims trailing and initial slashes
      .replace(/^\/+|\/+$/g, '')
      // Trims double slashes
      .replaceAll('//', '/')
  );
};
